import React from 'react'
import { Image, Flex, Box } from '@chatterbug/aaron'
import right from './assets/right.svg'
import left from './assets/left.svg'
import { t } from 'src/lib/i18n-react'

import Carousel from 'react-multi-carousel'
import { ArrowProps } from 'react-multi-carousel/lib/types'
import './assets/styles.scss'

interface CustomArrowProps extends ArrowProps {
  type: string
}

const CustomArrow = ({ onClick, type }: CustomArrowProps) => {
  const isBackButton = type === 'left'
  const arrowStyle = {
    background: 'transparent',
    border: 0,
    color: '#fff',
    // instead of absolute to overcome the overflow: hidden of the parent and be able to peak out on the side
    position: 'fixed',
    right: isBackButton ? null : '-5px',
    left: isBackButton ? '-5px' : null,
  }
  return (
    <Box
      as="button"
      onClick={onClick}
      bg="white"
      borderRadius="100%"
      p="0"
      sx={{
        ...arrowStyle,
        ':hover, :active': {
          backgroundColor: 'gray88',
        },
      }}
      aria-label={isBackButton ? t('previous') : t('next')}
    >
      <Image src={isBackButton ? left : right} width={32} height={32} alt="" />
    </Box>
  )
}

const responsive = {
  large: {
    breakpoint: { max: 4000, min: 1200 },
    items: 5,
  },
  medium: {
    breakpoint: { max: 1199, min: 1024 },
    items: 5,
  },
}

export type Props = {
  ItemComponent: any
  items: any[]
  onClick?: () => void
  onOrderChange?: (login: string, newValue: boolean) => any
  customPanelStyle?: Record<string, unknown>
  customItemStyle?: Record<string, unknown>
}

const HorizontallyScrollablePanel: React.FC<Props> = ({
  items,
  ItemComponent,
  onClick,
  onOrderChange,
  customPanelStyle,
  customItemStyle,
}) => {
  return (
    <>
      {/* FOR LARGER SCREENS */}
      <Flex
        display={{ mobile: 'none', tabletWide: 'flex' }}
        // needed to make arrows be fixed in relation to the parent and not the viewport
        sx={{ transform: 'translateZ(0)' }}
        {...customPanelStyle}
      >
        <Carousel
          containerClass="container"
          keyBoardControl
          responsive={responsive}
          draggable={false}
          slidesToSlide={5}
          customRightArrow={<CustomArrow type="right" />}
          customLeftArrow={<CustomArrow type="left" />}
          customTransition={'transform 600ms ease-out'}
        >
          {items?.map((item, index) => {
            return (
              <ItemComponent
                {...item}
                key={`item-${index}`}
                onClick={onClick}
                onOrderChange={onOrderChange}
                customStyle={customItemStyle}
              />
            )
          })}
        </Carousel>
      </Flex>
      {/* FOR TABLET & MOBILE */}
      <Flex
        className="hide-scrollbar"
        display={{ _mobile: 'flex', tabletWide: 'none' }}
        p="1x"
        sx={{
          overflowX: 'auto',
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        {...customPanelStyle}
      >
        {items?.map((item, index) => {
          return (
            <Box mr="1x" flexShrink="0" px="0,5x" key={`item-${index}`}>
              <ItemComponent
                {...item}
                onClick={onClick}
                onOrderChange={onOrderChange}
                customStyle={customItemStyle}
              />
            </Box>
          )
        })}
      </Flex>
    </>
  )
}

export default HorizontallyScrollablePanel
